import { useEffect } from "react";
import type { ErrorToastProps } from "./useErrorToast";
import useFetchErrorNotifier from "./useFetchErrorNotifier";

// Un store du SDK est lu par plusieurs composants : sans ce registre, chacun signalerait la même erreur.
const notifiedErrors = new WeakSet<Error>();

/** Signale une fois l'erreur d'un store partagé du SDK. */
const useLiveErrorNotifier = (
    error: Error | undefined,
    toastProps: ErrorToastProps,
) => {
    const notifyFetchError = useFetchErrorNotifier();

    useEffect(() => {
        if (!error || notifiedErrors.has(error)) return;
        notifiedErrors.add(error);

        notifyFetchError(toastProps);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error]);
};

export default useLiveErrorNotifier;
